import actions from './actions';

const {
  LIST_CATEGORIA_SERVICIO,
  LIST_CATEGORIA_SERVICIO_SELECTBOX,
  CREATE_CATEGORIA_SERVICIO,
  READ_CATEGORIA_SERVICIO,
  UPDATE_CATEGORIA_SERVICIO,    
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},   
};


const categoriaServiciosCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_CATEGORIA_SERVICIO:
      return {
        ...state,
        data: data
      }
    case LIST_CATEGORIA_SERVICIO_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case CREATE_CATEGORIA_SERVICIO:
      return {
        ...state,
        record: data
      }
    case READ_CATEGORIA_SERVICIO:
      return {
        ...state,
        record: data
      }
    case UPDATE_CATEGORIA_SERVICIO:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};


export default categoriaServiciosCrudReducer;
